import { FaRegCircle, FaRegSquare } from "react-icons/fa";

export default function AdvancedOptionsEditor({ question, onUpdate }) {
  const isCheckbox = question.select === "Checkboxes";
  const options = question.options || [];

  const updateOption = (index, value, key = "value") => {
    const updated = [...options];
    updated[index][key] = value;
    onUpdate(question.id, { options: updated });
  };

  const removeOption = (index) => {
    onUpdate(question.id, { options: options.filter((_, i) => i !== index) });
  };

  const addOption = () => {
    onUpdate(question.id, {
      options: [...options, { index: options.length, value: "" }],
    });
  };

  return (
    <div>
      {options.map((opt, i) => (
        <div key={i} className="flex items-center gap-2 mb-4">
          {isCheckbox ? (
            <FaRegSquare className="text-gray-50 rounded-sm border border-gray-300" />
          ) : (
            <FaRegCircle className="text-gray-50 rounded-lg border border-gray-300" />
          )}
          <input
            value={opt.value}
            onChange={(e) => updateOption(i, e.target.value)}
            className="flex-1 px-3 py-2 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-blue-500 focus:border-blue-500 focus:outline-none text-gray-900"
            placeholder={`Option ${i + 1}`}
          />
          {question.hasNotes && (
            <input
              value={opt.notes || ""}
              onChange={(e) => updateOption(i, e.target.value, "notes")}
              className="w-1/3 px-3 py-2 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-blue-500 focus:border-blue-500 focus:outline-none text-gray-900"
              placeholder="Notes"
            />
          )}
          <button onClick={() => removeOption(i)}>
            <svg
              className="w-6 h-6 text-red-600 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fillRule="evenodd"
                d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      ))}
      <button
        onClick={addOption}
        className="text-blue-600 text-sm font-medium flex items-center gap-1"
      >
        <svg
          className="w-5 h-5 text-blue-600 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 7.757v8.486M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
        Add Option
      </button>
    </div>
  );
}
